import _default from './Dimmer';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ../node_modules/semantic-ui-react/dist/es/modules/Dimmer/index.js
// module id = 373
// module chunks = 0